import SettingsModule from 'automation-ui-canvas/containers/settings/v2/SettingsModule';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useCallback } from 'react';
import LockedNotificationsToggle from 'automation-ui-canvas/components/settings/v2/LockedNotificationsToggle';
import makeDefaultNotificationConfigsMap from 'automation-ui-canvas/containers/settings/utils/makeDefaultNotificationConfigsMap';
import { WORKFLOWS_RISK_NOTIFICATIONS } from 'automation-ui-canvas/constants/Scopes';
import UIIcon from 'UIComponents/icon/UIIcon';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import UIList from 'UIComponents/list/UIList';
import { EERIE } from 'HubStyleTokens/colors';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const IssuesNotificationSetting = ({
  readOnly,
  settings: {
    notifications
  },
  onChange,
  scrollTo
}) => {
  const notificationConfig = notifications ? notifications.notificationConfigs.ISSUE_NOTIFICATION : makeDefaultNotificationConfigsMap().ISSUE_NOTIFICATION;
  const handleChange = useCallback(updatedNotificationConfig => {
    const updatedNotificationSetting = Object.assign({}, notifications);
    updatedNotificationSetting.notificationConfigs.ISSUE_NOTIFICATION = updatedNotificationConfig;
    onChange({
      notifications: updatedNotificationSetting
    });
  }, [notifications, onChange]);
  return /*#__PURE__*/_jsx(SettingsModule, {
    header: /*#__PURE__*/_jsx(UITooltip, {
      use: "longform",
      placement: "top",
      title: /*#__PURE__*/_jsxs(UIList, {
        styled: true,
        children: [/*#__PURE__*/_jsx("li", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "platformSettings.notificationSubscriptions.issueNotificationsTile.howItWorks.tooltip.firstTimeOccurs"
          })
        }), /*#__PURE__*/_jsx("li", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "platformSettings.notificationSubscriptions.issueNotificationsTile.howItWorks.tooltip.afterReviewing"
          })
        }), /*#__PURE__*/_jsx("li", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "platformSettings.notificationSubscriptions.issueNotificationsTile.howItWorks.tooltip.newIssuesOccur"
          })
        })]
      }),
      children: /*#__PURE__*/_jsxs("span", {
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "settingsV2.issuesNotificationSetting.title"
        }), /*#__PURE__*/_jsx(UIIcon, {
          name: "info",
          color: EERIE,
          className: "m-left-1"
        })]
      })
    }),
    body: /*#__PURE__*/_jsx(LockedNotificationsToggle, {
      scope: WORKFLOWS_RISK_NOTIFICATIONS,
      checked: notificationConfig.isEnabled,
      onChange: ({
        target: {
          checked
        }
      }) => {
        if (checked) {
          setTimeout(() => scrollTo('notificationRecipientsSetting'), 100);
        }
        handleChange(Object.assign({}, notificationConfig, {
          isEnabled: checked
        }));
      },
      readOnly: readOnly
    })
  });
};
export default IssuesNotificationSetting;